import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "swiper/css";
import SmartLazyImage from "./SmartLazyImage";

const BrochureCarousel = ({ brochures }) => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="relative max-w-xl mx-auto px-4">
      {/* Left Arrow */}
      <button
        onClick={() => swiperRef.current?.slidePrev()}
        disabled={activeIndex === 0}
        className={`absolute -left-5 top-1/2 -translate-y-1/2 z-10 p-2 bg-white/90 rounded-full shadow-md transition ${
          activeIndex === 0
            ? "opacity-40 cursor-not-allowed"
            : "hover:bg-gray-100"
        }`}
      >
        <ChevronLeft size={24} />
      </button>

      {/* Right Arrow */}
      <button
        onClick={() => swiperRef.current?.slideNext()}
        disabled={activeIndex === brochures.length - 1}
        className={`absolute -right-5 top-1/2 -translate-y-1/2 z-10 p-2 bg-white/90 rounded-full shadow-md transition ${
          activeIndex === brochures.length - 1
            ? "opacity-40 cursor-not-allowed"
            : "hover:bg-gray-100"
        }`}
      >
        <ChevronRight size={24} />
      </button>

      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        slidesPerView={1}
        spaceBetween={24}
        allowTouchMove
        className="w-full"
      >
        {brochures.map((src, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <div className="w-full h-[70vh] flex items-center justify-center bg-white">
                <img
                  src={src}
                  alt={`Brochure ${index + 1}`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Progress */}
      <div className="flex justify-center mt-6">
        <div className="w-32 h-1 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-green-700 transition-all duration-500"
            style={{
              width: `${((activeIndex + 1) / brochures.length) * 100}%`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BrochureCarousel;
